<ng-container *transloco="let t">
  <form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit(inputForm)">
    <div class="mt-2 row">
      <div class="col-md-6 col-sm-12">
        <gt-enhanced-autocomplete label="{{t('select-department-session.deliveryPoint')}}" #deliveryPointCtl
          formControlName="deliveryPoint" [searchFn]="deliveryPointSearchFn" [labelFn]="deliveryPointLabelFn"
          (changed)="selectDeliveryPoint($event)" [valueMode]="'object'" [displayedValue]="deliveryPointLabel$ | async">
        </gt-enhanced-autocomplete>
      </div>
    </div>
  </form>
</ng-container>
